export const MODULES_WITH_AI_FUNCTIONALITIES = {
  REVIEW: {
    name: 'Revisar',
    pathRegex: /^\/service\/review\//,
  },
  FOLDERS: {
    name: 'Carpetas',
    pathRegex: /^\/service\/folders\//,
  },
};